import React, { useEffect } from 'react'

type Props = {
    theme?: string
}

const Botmind = (props: Props) => {
    const { theme } = props

    useEffect(() => {
        const bcSid = localStorage.getItem('bc-sid')
        const sessionId = bcSid && JSON.parse(bcSid)?.id
        const sessionOptions = {
            startOpen: true,
            customData: [{ key: 'theme', value: theme }]
        }
        if (window.botmindWidget) {
            sessionId
                ? window.botmindWidget
                      .loadSession(sessionId, sessionOptions)
                      .then(() => {
                          window.botmindWidget.show()
                      })
                      .catch((error: any) =>
                          console.error('error loading botmind session', error)
                      )
                : window.botmindWidget
                      .loadNewSession(sessionOptions)
                      .then((id: string) => {
                          window.botmindWidget.show()
                      })
                      .catch((error: any) =>
                          console.error(
                              'error loading new botmind session',
                              error
                          )
                      )
        }

        return () => {
            window.botmindWidget && window.botmindWidget.hide()
        }
    }, [])

    return null
}

export { Botmind }
